import React, { useState } from 'react';
import GlobalStyles from './styles/GlobalStyles';
import LandingPage from './components/LandingPage';
import RSVPModal from './components/RSVPModal';

export default function App() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <GlobalStyles />
      <LandingPage onRSVPClick={() => setShowModal(true)} />
      {showModal && <RSVPModal onClose={() => setShowModal(false)} />}
    </>
  );
}
